export const SUBMIT_ATTEMPTED = 'SUBMIT_ATTEMPTED';
export const DATE_FORMAT = 'DD-MMM-YYYY';
